import { buildAuthHeader, getStoredAuthToken, resolveServerBaseUrl } from "./backend-auth";

type RespuestaCarga = {
  success: boolean;
  message?: string;
  file?: {
    name?: string;
    url?: string;
  };
};

export async function subirArchivoPostulacion(params: {
  file: File;
  tipo: string;
  platform?: string;
  version?: string;
}) {
  if (!(params.file instanceof File)) {
    throw new Error("Selecciona un archivo válido para continuar.");
  }

  const tipo = String(params.tipo ?? "").trim();
  if (!tipo) {
    throw new Error("Debes especificar el tipo de documento.");
  }

  const fileName = params.file.name || "documento";
  const fileSize = params.file.size || 0;
  const maxBytes = 10 * 1024 * 1024;
  if (fileSize <= 0 || fileSize > maxBytes) {
    throw new Error("El archivo supera el tamaño permitido de 10 MB.");
  }

  const formData = new FormData();
  formData.append("file", params.file);
  formData.append("fileubication", "careers_documents");
  formData.append("platform", params.platform ?? "Careers");
  formData.append("version", params.version ?? "1.0.0");
  formData.append("uid", "PostulacionPublica");

  const headers = new Headers();
  const authHeader = buildAuthHeader(getStoredAuthToken());
  if (authHeader) headers.set("Authorization", authHeader);

  const response = await fetch(`${resolveServerBaseUrl()}/uploads/charge`, {
    method: "POST",
    body: formData,
    headers,
  });

  const payload = (await response.json().catch(() => null)) as RespuestaCarga | null;
  if (!response.ok || !payload?.success || !payload?.file?.url || !payload?.file?.name) {
    throw new Error(payload?.message || `No se pudo subir el documento: ${tipo}.`);
  }

  return {
    tipo,
    nombre_archivo: payload.file.name || fileName,
    ruta: payload.file.url,
  };
}
